import { useTranslations } from '@vocab/react';
import {
  Box,
  Button,
  IconPersonVerified,
  Text,
  TooltipRenderer,
} from 'braid-design-system';
import type { FC } from 'react';

import translations from './.vocab';

interface UpgradeReferencesIconButtonProps {
  onClick: () => void;
}

export const UpgradeReferencesIconButton: FC<
  UpgradeReferencesIconButtonProps
> = ({ onClick }) => {
  const { t } = useTranslations(translations);
  const buttonLabel = t('Upgrade references');

  return (
    <TooltipRenderer tooltip={<Text size="small">{buttonLabel}</Text>}>
      {({ triggerProps }) => (
        <Box {...triggerProps}>
          <Button
            tabIndex={-1}
            tone="neutral"
            variant="soft"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onClick();
            }}
            aria-label={buttonLabel}
          >
            <IconPersonVerified />
          </Button>
        </Box>
      )}
    </TooltipRenderer>
  );
};
